module.exports = __webpack_public_path__ + "static/media/undraw_towing_6yy4.4271a618.png";